import { WSFilter } from "@wingspanhq/fe-component-library";
import { useMemo } from "react";
import { usePayerFilterOptions } from "../../../../Payers/hooks/usePayerFilterOptions";
import { InvoiceFilterKey, InvoiceVisibleFilters } from "./types";

export function useBuildConfig(
  visibleFilters?: InvoiceVisibleFilters
): WSFilter[] {
  const clientOptions = usePayerFilterOptions();

  return useMemo((): WSFilter[] => {
    const config: WSFilter[] = [
      {
        title: "Client",
        name: "clientId",
        type: "select",
        apiOptions: clientOptions
      },
      {
        title: "Due date",
        name: "dueDateRange",
        type: "daterange",
        titleInLabel: true,
        options: ["all", "pastWeek", "pastMonth", "yearToDate", "custom"]
      },
      {
        title: "Paid date",
        name: "paidDateRange",
        type: "daterange",
        titleInLabel: true,
        options: ["all", "pastWeek", "pastMonth", "yearToDate", "custom"]
      }
    ];

    if (!visibleFilters) {
      return config;
    }

    return config.filter(
      f => visibleFilters[f.name as InvoiceFilterKey] === true
    );
  }, [clientOptions, visibleFilters]);
}
